/**
 * DeliveryVehicleResponse
 * @author koba
 */
import {$, ID, Model, Resource} from 'simpli-web-sdk'
import DeliveryVehicleResponseSchema from '@/schema/DeliveryVehicleResponse.schema.ts'

export default class DeliveryVehicleResponse extends Resource {

  readonly $name: string = 'DeliveryVehicleResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-veiculo'

  get $schema() {
    return DeliveryVehicleResponseSchema(this)
  }

  $id = 0
  nome: string | null = null
  qtdSemOcorrencia: number | null  = null
  qtdComOcorrencia: number | null  = null
  qtdDevolvidas: number | null  = null
  qtdTotal: number | null = null

}
